// extracted by mini-css-extract-plugin
module.exports = {"settings":"MigrateProperty_settings__18If7","checkbox":"MigrateProperty_checkbox__1i9mx"};